const initailState = {
    arr:[]
}
const Fdata=(state=initailState,action)=>{
    switch(action.type){
        case 'ADDDATA':
            return{ 
                ...state,
                arr: state.arr.concat(action.payload)
            }
        default:
            return state;
    }
}

export default Fdata;